import { render, staticRenderFns } from "./FiltroNotas.vue?vue&type=template&id=548473c0&"
import script from "./FiltroNotas.vue?vue&type=script&lang=js&"
export * from "./FiltroNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports